import React, { useState } from "react";
import Chart from "react-apexcharts";

const YourPlan = () => {
  const [chartData] = useState({
    series: [
      {
        name: "Peak Upload",
        data: [15, 30, 10, 5, 20, 25, 40, 50, 30, 60, 70, 20],
      },
      {
        name: "Peak Download",
        data: [25, 55, 20, 10, 30, 35, 60, 80, 45, 90, 120, 40],
      },
    ],
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: { show: false },
      },
      colors: ["#00BFFF", "#3CB371"], // blue for upload, green for download
      plotOptions: {
        bar: {
          columnWidth: "60%",
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: [
          "08/12/25",
          "08/13/25",
          "08/14/25",
          "08/15/25",
          "08/16/25",
          "08/17/25",
          "08/18/25",
          "08/19/25",
          "08/20/25",
          "08/21/25",
          "08/22/25",
          "08/23/25",
        ],
        labels: {
          rotate: -45,
        },
      },
      yaxis: {
        title: { text: "Peak Mbps" },
        labels: {
          formatter: (val: number) => `${val.toFixed(0)}`,
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
      },
      grid: {
        borderColor: "#e0e0e0",
        strokeDashArray: 3,
      },
      tooltip: {
        y: {
          formatter: (val: number) => `${val} Mbps`,
        },
      },
    },
  });

  return (
    <div>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default YourPlan;